import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, VNode, createRef } from 'intact-vue';
import template from './column.vdt';
import { useGroup } from './useGroup';
import { useConfigContext } from '../config';
var typeDefs = {
  key: {
    type: String,
    required: true
  },
  title: [String, Number, VNode],
  sortable: Boolean,
  width: [String, Number],
  group: Array,
  multiple: Boolean,
  ignore: Boolean,
  fixed: ['left', 'right'],
  align: ['left', 'center', 'right'],
  exportTitle: String,
  exportCell: Function,
  minWidth: Number,
  // offset: null,
  cols: null,
  rows: null,
  prevVNode: null,
  nextVNode: null
};
export var TableColumn = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TableColumn, _Component);
  function TableColumn() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.elementRef = createRef();
    _this.group = useGroup();
    _this.config = useConfigContext();
    return _this;
  }
  return TableColumn;
}(Component);
TableColumn.template = template;
TableColumn.typeDefs = typeDefs;